import { combineReducers } from 'redux';
import {
  OPEN_PLATFORM_MY_APP_SET_APPS,
  OPEN_PLATFORM_MY_APP_SET_REMOVED_APP,
  OPEN_PLATFORM_MY_APP_SHOW_CONFIRM_REMOVE_MODAL,
  OPEN_PLATFORM_MY_APP_HIDE_CONFIRM_REMOVE_MODAL,
  OPEN_PLATFORM_MY_APP_SET_SUBMIT,
  OPEN_PLATFORM_MY_APP_SET_BUSINESS,
} from 'actions/openPlatform/myApp/constants';

import createReducer from 'utils/createReducer';

const apps = createReducer([], {
  [OPEN_PLATFORM_MY_APP_SET_APPS]: (draft, { payload }) => payload.apps,
});

const business = createReducer(
  { name: '', outlet_count: '' },
  {
    [OPEN_PLATFORM_MY_APP_SET_BUSINESS]: (draft, { payload }) =>
      payload.business,
  }
);

const removedApp = createReducer(
  {},
  {
    [OPEN_PLATFORM_MY_APP_SET_REMOVED_APP]: (draft, { payload }) => ({
      ...payload.app,
    }),
  }
);

const showConfirmRemoveModal = createReducer(false, {
  [OPEN_PLATFORM_MY_APP_SHOW_CONFIRM_REMOVE_MODAL]: () => true,
  [OPEN_PLATFORM_MY_APP_HIDE_CONFIRM_REMOVE_MODAL]: () => false,
});

const submit = createReducer('', {
  [OPEN_PLATFORM_MY_APP_SET_SUBMIT]: (draft, { payload }) => payload.submit,
});

export default combineReducers({
  apps,
  business,
  removedApp,
  showConfirmRemoveModal,
  submit,
});
